function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { SimpleContainer, CssContainer } from "../../components/container";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import LocationGrid from "../../components/locations-grid";
import MarketDrawer from "../../components/market-drawer";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import { Button } from '@progress/kendo-react-buttons';
import Query from "../../functions/query";
import ServiceFactory from '../../service';
import ManageDataTabs from '../../components/manage-data-tabs';
import { manageDataLegacyHere } from '../../functions/tenant-features';
import DataShell, { Btn } from '../manage-data/shell';
import { RowMenu, DlCard, DlFoot, DlPager, fmtInt } from '../manage-product/dl-kit';

// Kit helpers. A store market carries a street address; an area market carries geo targets (ZIP codes),
// the same split the market drawer derives.
const isStore = r => !!String(r && r.streetAddress || '').trim();
const zipCount = r => (r && r.locationGeoTargets || []).filter(g => String(g.type || '').toLowerCase() === 'postalcode').length;
// Stored addresses can be all lower case; show them the way people write them (state codes in capitals).
const caps = v => {
  const t = String(v || '').trim();
  return t && t === t.toLowerCase() ? t.replace(/(^|[\s\-'.])([a-z])/g, (m, p1, c) => p1 + c.toUpperCase()).replace(/\b(Sw|Se|Nw|Ne)\b/g, m => m.toUpperCase()) : t;
};
const addressOf = r => {
  const region = String(r.region || '').trim();
  const tail = [region.length === 2 ? region.toUpperCase() : caps(region), r.postalCode].filter(Boolean).join(' ');
  return [caps(r.streetAddress), caps(r.streetAddress2), caps(r.city), tail].map(x => String(x || '').trim()).filter(Boolean).join(', ');
};

/*
 * Markets tab — upload path unchanged; manual add/edit/delete added per
 * PlunkDocs specs/mockups/manage-data-manual-edit.html §1 (endpoints built
 * 2026-08-02). Row Edit opens the drawer prefilled from the LIST row (it
 * already carries locationGeoTargets — no detail fetch, no id-precision
 * hazard); row Delete confirms inline with the campaign warning.
 */
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onButtonClick", event => {
      this.gotoPage('/Locations/Upload');
    });
    _defineProperty(this, "onSaved", () => {
      const wasCreate = !this.state.editing;
      this.setState({
        drawer: false,
        editing: null
      });
      var toast = document.querySelector("paper-toast");
      // §217 expectation copy: a new market shows in Market Intelligence
      // once tracked stats roll up — never a silent nothing.
      if (toast) toast.show(wasCreate ? "Market saved — it appears in Market Intelligence as data collects; first numbers land within a day. It's also targetable in your next flight." : "Market saved.");
      if (this.props.onRefresh) this.props.onRefresh();
    });
    _defineProperty(this, "confirmDelete", async () => {
      var row = this.state.deleting;
      if (!row) return;
      this.setState({
        busy: true
      });
      var toast = document.querySelector("paper-toast");
      try {
        var api = `/location/${String(row.id)}`;
        var Service = ServiceFactory.getType(api, 'location');
        await new Service().deleteAsync();
        if (toast) toast.show(`Deleted “${row.name}”.`);
        this.setState({
          deleting: null,
          busy: false
        });
        if (this.props.onRefresh) this.props.onRefresh();
      } catch (err) {
        if (toast) toast.show(err.message || "Delete failed.");
        this.setState({
          busy: false
        });
      }
    });
    this.state = {
      drawer: false,
      editing: null,
      deleting: null,
      busy: false,
      kind: 'all'
    };
  }
  componentDidMount() {
    publishSearch('Locations');
    publishEvent('reset-search', {});
    // §217 deep-link: /Locations?add=1[&return=mi] opens the Add Market
    // drawer straight away (the MI header's "+ Add Market" lands here).
    try {
      const qs = new URLSearchParams(window.location.search);
      if (qs.get('add') === '1') this.setState({
        drawer: true,
        editing: null,
        returnTo: qs.get('return') || null
      });else if (qs.get('return')) this.setState({
        returnTo: qs.get('return')
      });
    } catch (e) {/* no query support — normal landing */}
  }
  renderKit(baseUrl, refreshUrl, data, del) {
    const rows = Array.isArray(data) ? data : [];
    const kind = this.state.kind || 'all';
    const stores = rows.filter(isStore);
    const areas = rows.filter(r => !isStore(r));
    const shown = kind === 'store' ? stores : kind === 'area' ? areas : rows;
    const noZip = areas.filter(r => zipCount(r) === 0).length;
    const total = this.props.pagination && this.props.pagination.count != null ? Number(this.props.pagination.count) : rows.length;
    const edit = row => this.setState({
      drawer: true,
      editing: row
    });
    const actions = /*#__PURE__*/React.createElement(React.Fragment, null, this.state.returnTo === 'mi' && /*#__PURE__*/React.createElement("a", {
      className: "wa-rowlink muted",
      onClick: () => this.gotoPage('/MarketIntelligence')
    }, "Back to Market Intelligence"), /*#__PURE__*/React.createElement(Btn, {
      onClick: this.onButtonClick
    }, "Upload markets"), /*#__PURE__*/React.createElement(Btn, {
      primary: true,
      onClick: () => this.setState({
        drawer: true,
        editing: null
      })
    }, "Add a market"));
    const pill = (k, label, n) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      className: `dl-pill${kind === k ? ' on' : ''}`,
      "aria-pressed": kind === k,
      onClick: () => this.setState({
        kind: k
      })
    }, label, " ", fmtInt(n));
    return /*#__PURE__*/React.createElement(DataShell, {
      active: "/Locations",
      subtitle: "Where your data comes from and how Plunk uses it",
      actions: actions
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-grid dl-view"
    }, /*#__PURE__*/React.createElement(DlCard, {
      title: "Your markets",
      hint: `${fmtInt(total)} · used for the maps, Market Intelligence and ad targeting`
    }, /*#__PURE__*/React.createElement("div", {
      className: "dl-pills"
    }, pill('all', 'All', rows.length), pill('store', 'Stores', stores.length), pill('area', 'Areas', areas.length)), shown.length ? /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table dl-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Market"), /*#__PURE__*/React.createElement("th", null, "Kind"), /*#__PURE__*/React.createElement("th", null, "Where"), /*#__PURE__*/React.createElement("th", {
      className: "dl-act",
      "aria-label": "Actions"
    }))), /*#__PURE__*/React.createElement("tbody", null, shown.map(row => {
      const store = isStore(row);
      const zips = zipCount(row);
      return /*#__PURE__*/React.createElement("tr", {
        key: String(row.id)
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        className: "dl-name",
        onClick: () => edit(row)
      }, row.name || 'Untitled market')), /*#__PURE__*/React.createElement("td", null, store ? /*#__PURE__*/React.createElement("span", {
        className: "dl-chip blue"
      }, "Store") : /*#__PURE__*/React.createElement("span", {
        className: "dl-chip grey"
      }, "Area")), /*#__PURE__*/React.createElement("td", null, store ? /*#__PURE__*/React.createElement("span", {
        className: "dl-addr"
      }, addressOf(row)) : zips > 0 ? /*#__PURE__*/React.createElement("span", null, fmtInt(zips), " ZIP ", zips === 1 ? 'code' : 'codes') : /*#__PURE__*/React.createElement("span", {
        className: "dl-amber"
      }, "No ZIP codes yet \xB7 ", /*#__PURE__*/React.createElement("a", {
        onClick: () => edit(row)
      }, "Add the area"))), /*#__PURE__*/React.createElement("td", {
        className: "dl-act"
      }, /*#__PURE__*/React.createElement(RowMenu, {
        label: row.name || 'market',
        items: [{
          label: 'Edit',
          onClick: () => edit(row)
        }, {
          label: 'Delete',
          danger: true,
          onClick: () => this.setState({
            deleting: row
          })
        }]
      })));
    })))) : /*#__PURE__*/React.createElement("p", {
      className: "dl-empty"
    }, rows.length ? 'No markets of this kind yet.' : 'No markets yet. Add a market or upload a file of them.'), noZip > 0 || this.props.pagination && Number(this.props.pagination.pageCount) > 1 ? /*#__PURE__*/React.createElement(DlFoot, {
      tone: noZip > 0 ? 'amber' : null,
      right: /*#__PURE__*/React.createElement(DlPager, {
        pagination: this.props.pagination,
        onGo: this.onPageRequest,
        noun: "markets"
      })
    }, noZip > 0 ? `${fmtInt(noZip)} ${noZip === 1 ? "area has" : "areas have"} no ZIP codes yet, so ${noZip === 1 ? "it can't" : "they can't"} be shown on the maps or targeted.` : null) : null)), this.state.drawer && /*#__PURE__*/React.createElement(MarketDrawer, {
      market: this.state.editing,
      onClose: () => this.setState({
        drawer: false,
        editing: null
      }),
      onSaved: this.onSaved
    }), del && /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop",
      onClick: e => {
        if (e.target === e.currentTarget && !this.state.busy) this.setState({
          deleting: null
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-modal"
    }, /*#__PURE__*/React.createElement("h3", null, "Delete market"), /*#__PURE__*/React.createElement("p", null, "Delete ", /*#__PURE__*/React.createElement("b", null, del.name), del.referenceId ? /*#__PURE__*/React.createElement(React.Fragment, null, " (ref ", /*#__PURE__*/React.createElement("code", null, del.referenceId), ")") : null, "? Its ZIP codes and other places are removed too."), /*#__PURE__*/React.createElement("p", {
      className: "dim"
    }, "If an active campaign uses this market, its results lose their market grouping."), /*#__PURE__*/React.createElement("div", {
      className: "acts"
    }, /*#__PURE__*/React.createElement(Btn, {
      disabled: this.state.busy,
      onClick: () => this.setState({
        deleting: null
      })
    }, "Cancel"), /*#__PURE__*/React.createElement(Btn, {
      danger: true,
      disabled: this.state.busy,
      onClick: this.confirmDelete
    }, this.state.busy ? 'Deleting…' : 'Delete market')))));
  }
  render() {
    var baseUrl = '/Locations';
    var refreshUrl = '/Locations';
    var data = this.props.data;
    var del = this.state.deleting;
    if (!manageDataLegacyHere()) return this.renderKit(baseUrl, refreshUrl, data, del);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view"
    }, /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Manage Data"), /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'inline-flex',
        gap: '8px',
        alignItems: 'center'
      }
    }, this.state.returnTo === 'mi' && /*#__PURE__*/React.createElement("a", {
      style: {
        cursor: 'pointer',
        fontSize: '13px'
      },
      onClick: () => this.gotoPage('/MarketIntelligence')
    }, "\u2190 Back to Market Intelligence"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        drawer: true,
        editing: null
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "add"), " Add Market"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onButtonClick
    }, "Upload Markets ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_forward")))), /*#__PURE__*/React.createElement(ManageDataTabs, {
      active: "/Locations"
    }), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(LocationGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest,
      onEdit: row => this.setState({
        drawer: true,
        editing: row
      }),
      onDelete: row => this.setState({
        deleting: row
      })
    })), this.state.drawer && /*#__PURE__*/React.createElement(MarketDrawer, {
      market: this.state.editing,
      onClose: () => this.setState({
        drawer: false,
        editing: null
      }),
      onSaved: this.onSaved
    }), del && /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,35,.45)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      onClick: e => {
        if (e.target === e.currentTarget && !this.state.busy) this.setState({
          deleting: null
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: '#fff',
        borderRadius: '10px',
        width: '420px',
        maxWidth: '92%',
        padding: '20px 22px',
        boxShadow: '0 12px 40px rgba(0,0,0,.25)'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label",
      style: {
        fontSize: '16px',
        marginBottom: '8px'
      }
    }, "Delete market"), /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: '13px',
        margin: '0 0 6px'
      }
    }, "Delete ", /*#__PURE__*/React.createElement("b", null, del.name), del.referenceId ? /*#__PURE__*/React.createElement(React.Fragment, null, " (ref ", /*#__PURE__*/React.createElement("code", null, del.referenceId), ")") : null, "? Its geo-targets are removed too."), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: '0 0 14px'
      }
    }, "If an active campaign references this market, its insights lose their market grouping."), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: this.state.busy,
      onClick: () => this.setState({
        deleting: null
      })
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "error",
      disabled: this.state.busy,
      onClick: this.confirmDelete
    }, this.state.busy ? 'Deleting…' : 'Delete market')))));
  }
}
export class LocationViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
    _defineProperty(this, "refresh", () => {
      this.fetchData();
    });
  }
  async fetchData() {
    let query = this.queryParams;
    let page = this.page;
    var api = '/location';
    var Service = ServiceFactory.getType(api, 'location');
    var service = new Service();
    var baseUrl = '/Locations';
    try {
      // The kit lists every market on one page (filter pills count them); the legacy grid keeps 10.
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: manageDataLegacyHere() ? 10 : 500
      }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).getAsync();
      this.data = data.items;
      this.pagination = data.pagination;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params,
        onRefresh: this.refresh
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  LocationViewComponent
};